<template>
	<journey-wrapper save>
		<app-alert v-if="!store.stepsComplete" theme="danger">
			You have incomplete steps
		</app-alert>

		<app-panel title="Photos" collapsible>
			<template #header>
				<ExclamationTriangleIcon v-if="!store.step2Complete" class="h-5 w-5 text-red-500" />
			</template>

			<div v-if="store.journey!.photo_skip_reason">
				<p class="text-sm">{{ store.journey!.photo_skip_reason }}</p>
			</div>

			<app-file-button
				v-else
				:value="files"
				name="photos"
				multiple
				confirm
				:save="unsavedFiles.length > 0 ? store.savePhotos : undefined"
				@file-change="(files: File[]) => (store.journey!.photos = files)">
				<app-icon :icon="['fas', 'fa-camera']" class="mr-1" />
				Add Photos
			</app-file-button>
		</app-panel>

		<app-panel title="Signature" :compact="store.step3Complete" collapsible class="mt-3">
			<template #header>
				<ExclamationTriangleIcon v-if="!store.step3Complete" class="h-5 w-5 text-red-500" />
			</template>

			<app-alert v-if="!store.journey!.signature" theme="danger" compact spacing="mb-0">
				Signature step is incomplete
			</app-alert>

			<div v-else class="flex justify-center">
				<img :src="store.journey!.signature" alt="Signature" class="max-w-full w-[300px]" />
			</div>
		</app-panel>

		<app-panel title="Survey Responses" :compact="store.step4Complete" collapsible class="mt-3">
			<template #header>
				<ExclamationTriangleIcon v-if="!store.step4Complete" class="h-5 w-5 text-red-500" />
			</template>

			<app-alert v-if="!store.step4Complete" theme="danger" compact spacing="mb-0">
				Survey step is incomplete
			</app-alert>

			<dl v-else class="divide-y divide-gray-100">
				<list-group-item
					v-for="(value, index) in store.filteredSurvey"
					:key="index"
					:label="value.question"
					:value="value.answer"
					compact />
			</dl>
		</app-panel>

		<div v-if="store.showActions">
			<app-panel title="Driver notes" class="mt-3">
				<app-input
					v-model="store.journey!.driver_notes"
					type="textarea"
					placeholder="Add notes here..." />
			</app-panel>
		</div>

		<journey-nav
			:current="5"
			:disabled="!store.stepsComplete"
			@confirmed="store.saveJourney(true)" />
	</journey-wrapper>
</template>

<script lang="ts" setup>
	import { computed } from 'vue'
	import JourneyNav from '@/components/partials/driver-app/JourneyNav.vue'
	import useDriverApp from '@/stores/driver-app'
	import JourneyWrapper from '@/components/layout/driver-app/JourneyWrapper.vue'
	import { ExclamationTriangleIcon } from '@heroicons/vue/20/solid'
	import ListGroupItem from '@/components/partials/ListGroupItem.vue'

	// Resources
	const store = useDriverApp()
	const files = computed(() => {
		return store.photos
	})
	const unsavedFiles = computed(() => {
		return store.unsavedPhotos
	})
</script>
